import styled from 'styled-components'

import Grid from '@material-ui/core/Grid'

export const Container = styled.div`
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 10px;
`

export const ModulesList = styled(Grid)`
  padding: 15px 0;
  max-height: 50vh;
  overflow: auto;
`
